/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkg_Log_Toast_UpdatedInputs */

const vi_pkg_log_toast_updated = /** @type {(inputs: Pkg_Log_Toast_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã cập nhật mẻ`)
};

/**

* @param {Pkg_Log_Toast_UpdatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkg_log_toast_updated = /** @type {((inputs?: Pkg_Log_Toast_UpdatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkg_Log_Toast_UpdatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkg_log_toast_updated(inputs)
});